declare global {
  interface Window {
    proxyFetch: typeof fetch;
  }
}

const urlRegex = /url\(['"]?([^'")\s]+)['"]?\)/g;

export const extractFontUrls = (css: string): string[] => {
  const fontUrlRegex = /@font-face\s*{[^}]*?src:\s*([^}]+?)}/g;
  const priority = ['woff2', 'woff', 'ttf', 'otf', 'svg'];
  const urls: string[] = [];
  let match;

  while ((match = fontUrlRegex.exec(css)) !== null) {
    let urlMatch;
    const foundUrls: string[] = [];

    while ((urlMatch = urlRegex.exec(match[1])) !== null) {
      foundUrls.push(urlMatch[1]);
    }

    for (const format of priority) {
      const selectedUrl = foundUrls.find(url => url.endsWith(`.${format}`));
      if (selectedUrl) {
        urls.push(selectedUrl);
        break;
      }
    }
  }

  return urls;
};

const downloadFontAsBase64 = async (url: string): Promise<string> => {
  const response = await window.proxyFetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const replaceFontUrlWithBase64 = (
  fontUrl: string,
  base64: string,
  css: string
) => {
  // Escape special regex characters in the fontUrl
  const escapedFontUrl = fontUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const fontUrlRegex = new RegExp(`url\\(['"]?${escapedFontUrl}['"]?\\)`, 'g');
  return css.replace(fontUrlRegex, `url(${base64})`);
};

export const replaceFontsAsInline = async (css: string): Promise<string> => {
  const fontUrls = extractFontUrls(css);

  let modifiedCss = css;

  await Promise.all(
    fontUrls.map(async fontUrl => {
      try {
        const base64Data = await downloadFontAsBase64(fontUrl);
        modifiedCss = replaceFontUrlWithBase64(
          fontUrl,
          base64Data,
          modifiedCss
        );
      } catch (error) {
        console.error(`Failed to download font: ${fontUrl}`, error);
      }
    })
  );

  return modifiedCss;
};
